<template>
  <section class="g-my-checkbox-box">
    <el-checkbox-group v-model="formInline.value" @change="selectStyle">
      <el-checkbox v-for="(item, i) in options" :key="i" :label="item.value" :title="item.label">{{ $t(item.label) }}</el-checkbox>
    </el-checkbox-group>
  </section>
</template>

<script>
import i18n from '../../language/index'

  export default {
    name: 'my_checkbox_box',
    components: {}, // 注册组件
    directives: {},
    props: {
      value: {
        type: Array,
        default: () => []
      },
      options: {
        type: Array,
        default: () => []
      }
    },
    watch: {
      options: {
        handler (val) {
          this.format()
          let selectData = []
          this.formInline.value.map(item => {
            for (let i = 0; i < val.length; i++) {
              if (item === val[i].value) {
                selectData.push(val[i])
              }
            }
          })
          this.$emit('change', this.formInline.value, selectData)
        },
        deep: true
      }
    },
    data () {
      return {
        formInline: {
          value: []
        },
        filter: {
        },
        loading: true
      }
    },
    computed: {}, // 计算属性
    beforeCreate () {},
    created () {
      this.format()
    },
    mounted () {},
    beforeUpdate () {},
    beforeDestroy () {},
    methods: {
      format () {
        this.formInline.value = this.value.filter(item => this.options.find(data => data.value === item) !== -1)
      },
      selectStyle (value) {
        this.$emit('input', value)
        let selectData = []
        value.map(item => {
          for (let i = 0; i < this.options.length; i++) {
            if (item === this.options[i].value) {
              selectData.push(this.options[i])
            }
          }
        })
        this.$emit('change', value, selectData)
      }
    }
  }
</script>

<style scoped lang="scss">
  .g-my-checkbox-box {
    overflow: auto;
    margin: 10px 0;
    padding: 14px 0 14px 14px;
    height: 155px;
    border: 1px solid #e3e2e8;
    .el-checkbox-group {
      display: flex;
      flex-wrap: wrap;
    }
    .el-checkbox {
      display: flex;
      margin-right: 15px;
      padding-bottom: 9px;
      width: calc(33% - 15px);
      align-items: center;
    }
  }
</style>

<style lang="scss">
  .g-my-checkbox-box {
    .el-checkbox__label {
      overflow: hidden;
      padding-left: 8px;
      width: 76px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/my_checkbox_box/index.vue